import React from "react";
import clsx from "clsx";

import * as styles from "./skeleton.css";

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  circle = false,
  className
}) => {
  return (
    <div
      className={clsx(styles.skeleton, circle && styles.circle, className)}
      style={{
        width: width,
        height: height
      }}
      data-testid="skeleton"
    />
  );
};

export default Skeleton;
